<template>
  <div class="bottomMain">
    <div class="bottomMain-item">
      <!--      <router-link to="/somepage3">-->
      <!--        <img class="image" src="../images/menu/achievments.svg" />-->
      <!--      </router-link>-->
    </div>
    <div class="bottomMain-item">
            <router-link to="/partners">
              <img class="image" style="width: 44px; height: 44px;" src="../images/menu/partners.svg" />
            </router-link>
    </div>
    <div class="bottomMain-item">
      <router-link to="/">
        <img class="image" src="../images/menu/home.svg" />
      </router-link>
    </div>
    <div class="bottomMain-item" v-if="userTg">
      <router-link to="/achievements">
        <img class="image" src="../images/menu/achievments.svg" />
      </router-link>
    </div>
    <div class="bottomMain-item">
      <router-link to="/terms" aria-label="Документы" title="Документы">
        <img class="image" src="../images/menu/documents.svg" alt="" />
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { getTelegramUser } from '@/helpers/telegram'

const userTg = getTelegramUser()
// пусто, логика маршрутов реализуется через Vue Router
</script>

<style scoped>
.bottomMain {
  height: 60px;
  background: rgba(35, 59, 87, 0.43);
  display: flex;
  justify-content: space-between; /* можно оставить center, если padding внутри */
  align-items: center;
  width: 100vw;
}

.bottomMain-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image {
  height: 38px;
  width: 38px;
}
</style>
